import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, AddCircleOutline, AddOutlined, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import CreateSpacePopup from "../Utils/CreateSpacePopup";

const SpacesList = () => {
    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const isoString = isostring;
    const desiredFormat = "dd MMMM yyyy, hh:mm:ss a";

    const indianTimeZone = "Asia/Kolkata";
    const zonedTime = utcToZonedTime(isoString, indianTimeZone);

    const formattedDate = format(zonedTime, desiredFormat, {
        timeZone: indianTimeZone,
    });

    return formattedDate;
};
function CommunityListView({ data }) {
    const [locations, setlocations] = useState(null);
    const [UserLastLocation, setUserLastLocation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [userProfile, setUserProfile] = useState({})
    const [showCreateSpacePopup, setShowCreateSpacePopup] = useState(false)


    const FetchCommunities = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/spaces/getall`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setCommunities(data.response);
            // setloading(false);
        }

    };

    useEffect(() => {
        async function getUserProfile() {
            const profile_obj = localStorage.getItem("profile")
            setUserProfile(JSON.parse(profile_obj))
        }
        getUserProfile()
        FetchCommunities();
    }, []);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [communitites, setCommunities] = useState([])

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>
                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                    sx={{ flexWrap: 'wrap', flexDirection: 'row', gap: "10px",marginBottom: isMobileScreen ? "0px" : "20px", marginInline: isMobileScreen ? "0px" : "5px" }}
                >
                    <Header
                    imgInc={true}
                        title={`Spaces of communities`}
                        subtitle={`List of current spaces.`}
                    />


                    {
                        userProfile._id && userProfile.Role == "ADMIN" && (
                            <Box onClick={() => setShowCreateSpacePopup(true)} sx={{
                                flexDirection: 'row', alignItems: 'center', display: 'flex', background: "#ffffff10",
                                borderRadius: "8px", paddingInline: "12px", paddingBlock: "8px", gap: "5px",
                                border: "0px solid #ffffff40", cursor: 'pointer', userSelect: 'none',marginBottom: isMobileScreen ? "15px" : "0px"
                            }}>
                                <AddOutlined />
                                <Typography color={"#ffffff"}
                                    fontFamily={"poppins-reg"}
                                    fontSize={"14px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >New Space</Typography>

                            </Box>
                        )
                    }


                </Box>
                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>

                    <Box
                        display={"grid"}
                        gridTemplateColumns="repeat(12,1fr)"
                        gap="20px"
                        pb={"20px"}
                    >
                        {
                            communitites.map((community) => {
                                return (
                                    <Box
                                        // key={`${transaction.txId}-${i}`}
                                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                                        gridRow="span 2"
                                        display="flex"
                                        alignItems="center"
                                        px="15px"
                                        py={"8px"}
                                        component={Link}
                                        backgroundColor={"#ffffff07"}
                                        borderRadius={"15px"}
                                        to={{
                                            pathname: "/admin/space-dt",
                                            search: `?ref=${community._id}`,
                                            state: { fromDashboard: true },
                                            // console.log(first)
                                        }}

                                        sx={{
                                            textDecoration: 'none', paddingY: "15px", flexDirection: 'row', alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        {
                                            community.logo && (
                                                <Box mr={"20px"} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <img
                                                        alt="profile-user"
                                                        width="80px"
                                                        height="80px"
                                                        src={`${community.logo}`}
                                                        style={{
                                                            cursor: "pointer", objectFit: 'cover',
                                                            borderRadius: "50%",
                                                            border: "3px solid #ffffff10"
                                                        }}
                                                    />
                                                </Box>
                                            )
                                        }
                                        <Box sx={{ mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                ml={"3px"}
                                                fontSize={"16px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{community.name}</Typography>

                                            <Box sx={{
                                                display: 'flex', flexDirection: "row", alignItems: 'center', marginTop: "6px",
                                                gap: "5px"
                                            }}>
                                                <Typography color={"#752bffff"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        borderRadius: "100px",
                                                        background: "#752bff20",
                                                        paddingTop: "3px",
                                                        paddingBottom: "3px",
                                                        paddingLeft: "12px",
                                                        paddingRight: "12px"
                                                    }}
                                                    fontSize={"12px"}>{community.type}</Typography>
                                                <Typography color={"#aaaaaa"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        borderRadius: "100px",
                                                        background: "#aaaaaa20",
                                                        paddingTop: "3px",
                                                        paddingBottom: "3px",
                                                        paddingLeft: "12px",
                                                        paddingRight: "12px"
                                                    }}
                                                    fontSize={"12px"}>{community.communities.length} communities</Typography>
                                            </Box>
                                        </Box>

                                        {/* <Box sx={{
                                            height: "1.5px",
                                            background: "#aaaaaa20",
                                            alignSelf: 'stretch',
                                            marginY: "15px"
                                        }} />

                                        <Typography color={"#ffffff90"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"11px"}>Community Mail</Typography>

                                        <Typography color={"#ffffff"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"13px"}>{community.communityMail}</Typography>


                                        <Typography color={"#ffffff90"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            marginTop={"20px"}
                                            fontSize={"11px"}>Date Created</Typography>

                                        <Typography color={"#ffffff"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"13px"}>{Convert_Time_Zone(community.createdAt)}</Typography> */}


                                    </Box>
                                );
                            })}
                    </Box>

                </Box>

                <CreateSpacePopup
                    open={showCreateSpacePopup}
                    onClose={() => setShowCreateSpacePopup(false)}
                    onComplete={()=> {
                        setShowCreateSpacePopup(false)
                        FetchCommunities()
                    }}
                />

            </Box>
        </>
    );
}

export default SpacesList;
